import { MutationTree } from "vuex";
import * as types from './types'

export default <MutationTree<RootState>>{
  [types.CURRENT_MAIL_ITEM](state, payload: Office.MessageRead | null) {
    state.currentItem = payload;
  },

  [types.VALID_DOMAIN](state, payload: string[]) {
    state.validDomain = payload;
  },

  [types.PANE_LOADING](state, payload: boolean) {
    state.paneLoading = payload;
  },

  [types.ORIGINAL_RECIPIENTS_SET](state, payload: Recipient[]) {
    state.originalRecipients = payload;
  },

  [types.INDEXED_RECIPIENTS_SET](state, payload: Recipient[]) {
    state.indexedRecipients = payload;
  },

  [types.RECIPIENTS_WITH_STATUS_SET](state, payload: RecipientWithStatus[]) {
    state.recipientsWithStatus = payload;
  },

  [types.RECIPIENTS_WITH_STATUS_SELECT_CHANGE](state, payload: RecipientWithStatus) {
    let originalList = [ ...state.recipientsWithStatus ];
    let idx = originalList.findIndex(x => x.recipient == payload.recipient);

    if (idx > -1) {
      originalList[idx].isSelected = !originalList[idx].isSelected;
    }

    state.recipientsWithStatus = originalList;
  },

  [types.SEARCH_TARGET_SET](state, payload: Recipient[]) {
    state.searchTargetList = payload;
  },
};